// extracted by mini-css-extract-plugin
export default {"tableSummaryContainer":"BroadbandCheckoutPage_tableSummaryContainer__ZJaLx"};